import { DateTime } from "luxon"

const getLastMessageTimestamp = (timestamp: string): string | null => {
  const date = new Date(timestamp)
  const now = new Date()
  const diffInHours = (now.getTime() - date.getTime()) / (1000 * 60 * 60)

  if (diffInHours > 48) {
    return DateTime.fromJSDate(date).toFormat("MM.dd.yyyy")
  }

  return DateTime.fromJSDate(date).toRelative()
}

interface Props {
  timestamp: string
}

const Time = ({ timestamp }: Props) => {
  return (
    <time className="text-xs" dateTime={timestamp}>
      {getLastMessageTimestamp(timestamp)}
    </time>
  )
}

export default Time
